import { getMonitoringSteps } from './monitoring.steps';
import { getManagerSteps } from './manager.steps';
import { SHARED_STEPS } from './shared.steps';
import { getIndustrialSteps } from './industrial.steps';
import { getAdminSteps } from './admin.steps';

//fonction qui retourne les étapes du tour en fonction du module sélectionné
export function getStepsForModule(module, t) {
  switch (module) {
    case 'MONITORING':
      return getMonitoringSteps(t);
    
    case 'MANAGER':
      return getManagerSteps(t);

    case 'INDUSTRIAL':
      return getIndustrialSteps(t);
    case 'ADMIN':
      return getAdminSteps(t);
    default:
  return [
    SHARED_STEPS.welcome(t),
    SHARED_STEPS.done(t),
  ];
  }
}